import React from "react";
import "./CallToAction.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

import { useLanguage } from "../../context/LanguageContext";

const CallToAction = () => {
  const { t } = useLanguage();

  return (
    <section className="cta-section" id="contact">
      <div className="cta-container">

        {/* INFO */}
        <div className="cta-info">
          <h2>{t.cta.title}</h2>
          <p>{t.cta.subtitle}</p>

          <div className="cta-item">
            <FaPhoneAlt />
            <span>0658737849</span>
          </div>

          <div className="cta-item">
            <FaEnvelope />
            <span>moniechafaudage@outlook.fr</span>
          </div>

          <div className="cta-item">
            <FaMapMarkerAlt />
            <span>{t.cta.addressValue}</span>
          </div>
        </div>

        {/* MAP */}
        <div className="cta-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2681.443453218105!2d7.314970076799649!3d47.77284857648198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47919ca6aa65add1%3A0xdc0fcfc3b933d1e6!2s12f%20Rue%20de%20Ruelisheim%2C%2068200%20Mulhouse%2C%20France!5e0!3m2!1sen!2s!4v1768208634595!5m2!1sen!2s"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={t.cta.mapTitle}
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default CallToAction;
